"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileAttributesTable = exports.TileDrawingTable = exports.TileTable = void 0;
var TileTable_1 = require("./TileTable");
Object.defineProperty(exports, "TileTable", { enumerable: true, get: function () { return TileTable_1.TileTable; } });
var TileDrawingTable_1 = require("./TileDrawingTable/TileDrawingTable");
Object.defineProperty(exports, "TileDrawingTable", { enumerable: true, get: function () { return TileDrawingTable_1.TileDrawingTable; } });
var TileAttributesTable_1 = require("./TileAttributesTable/TileAttributesTable");
Object.defineProperty(exports, "TileAttributesTable", { enumerable: true, get: function () { return TileAttributesTable_1.TileAttributesTable; } });
